<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.JS_CODE.CODE'|translate }} <span class="required">*</span></label>
        <div class="editor">
            <ngx-monaco-editor class="h-100"
                               [options]="editorOptions()"
                               formControlName="code"
                               (onInit)="onInit($event)">
            </ngx-monaco-editor>
        </div>
    </div>
</div>